// public/js/features/announcements/api.js
export async function loadAnnouncements() {
  const res = await window.authenticatedFetch('api/v1/announcements');
  if (!res.ok) throw new Error(`Failed to load announcements (${res.status})`);
  return await res.json();   // { posts, lastReadSeq, latestSeq }
}

export async function markAnnouncementsRead() {
  try {
    await window.authenticatedFetch('api/v1/announcements/read', { method: 'POST' });
  } catch { /* best-effort */ }
}

export async function createAnnouncement(payload) {
  const res = await window.authenticatedFetch('api/v1/announcements', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Failed to create post');
  return (await res.json()).post;
}

export async function updateAnnouncement(seq, payload) {
  const res = await window.authenticatedFetch(`api/v1/announcements/${encodeURIComponent(seq)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error((await res.json().catch(() => ({}))).error || 'Failed to update post');
  return (await res.json()).post;
}

export async function deleteAnnouncement(seq) {
  const res = await window.authenticatedFetch(`api/v1/announcements/${encodeURIComponent(seq)}`, { method: 'DELETE' });
  if (!res.ok) throw new Error('Failed to delete post');
  return res.json();
}
